import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import PropTypes from 'prop-types';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import emptyFunction from 'react-utils/emptyFunction';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import TourContext from '../contexts/TourContext';
import handleCallback from '../lib/handleCallback';

const UITourBackButton = props => {
  const {
    tour
  } = useContext(TourContext);

  const {
    beforeBack,
    children = /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        UIIcon
      },
      options: {
        name: 'left'
      },
      message: "shepherd-react.back_jsx"
    })
  } = props,
        buttonProps = _objectWithoutPropertiesLoose(props, ["beforeBack", "children"]);

  if (!tour.canGoBack()) {
    return /*#__PURE__*/_jsx("div", {});
  }

  const {
    back,
    getTour,
    getStep
  } = tour;

  const handleClick = () => {
    const {
      tourKey = getTour(),
      stepKey = getStep()
    } = props;
    handleCallback(beforeBack, back, {
      tourKey,
      stepKey
    });
  };

  return /*#__PURE__*/_jsx(UIButton, Object.assign({}, buttonProps, {
    onClick: handleClick,
    children: children
  }));
};

UITourBackButton.propTypes = {
  beforeBack: PropTypes.func.isRequired,
  tourKey: PropTypes.string,
  stepKey: PropTypes.string,
  children: PropTypes.node
};
UITourBackButton.defaultProps = {
  beforeBack: emptyFunction
};
export default UITourBackButton;